import { Box, Card, Text, Title } from '@nimbus-ds/components';
import { PaymentInfoAbandonedCartDetailsResponseDto } from '@tiendanube/common';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { LatestPaymentAttempt } from './LatestPaymentAttempt';
import { PreviousPaymentAttempts } from './PreviousPaymentAttempts';

interface PaymentAttemptsCardProps {
  paymentInfo: PaymentInfoAbandonedCartDetailsResponseDto;
}

export function PaymentAttemptsCard({
  paymentInfo,
}: Readonly<PaymentAttemptsCardProps>) {
  const t = useTranslationOrders();

  const attempts = paymentInfo.paymentAttempts;
  const latestAttempt = attempts && attempts.length > 0 ? attempts[0] : null;

  const gateway = paymentInfo.gateway ?? '';
  const method = paymentInfo.gatewayMethod ?? '';
  const installments = paymentInfo.installments;
  const paymentCount = paymentInfo.paymentCount;

  return (
    <Card>
      <Card.Header>
        <Title as="h4">{t('cardPayment.paymentType')}</Title>
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="2">
          {latestAttempt ? (
            <>
              <LatestPaymentAttempt attempt={latestAttempt} />
              <PreviousPaymentAttempts
                attempts={attempts ?? []}
                paymentCount={paymentCount}
              />
            </>
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              gap="2"
              alignItems="flex-start"
            >
              {gateway !== '' && (
                <Text fontWeight="bold">
                  {t(`gateway.${gateway}`, gateway)}
                </Text>
              )}
              {method !== '' && <Text>{method}</Text>}
              {!!installments && installments > 1 && (
                <Text>
                  {t('cardPayment.installments', { count: installments })}
                </Text>
              )}
              {!!paymentCount && (
                <Text>
                  {t('cardPayment.paymentCount', { count: paymentCount })}
                </Text>
              )}
            </Box>
          )}
        </Box>
      </Card.Body>
    </Card>
  );
}
